module.exports = __webpack_public_path__ + "static/img/hahmo-immateriaalioikeudet.679960b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hahmo-immateriaalioikeudet.png
// module id = 7QaH
// module chunks = 1